import React, { Component }     from "react"
import { connect }              from "react-redux"
import {
    BrowserRouter,
    Route,
    Switch,
}                               from "react-router-dom"
import infraMonitorService      from "../../api/infraMonitorService"
import { Loader }               from "../../components/layouts"
import { RedirectAdmin }        from "../../components/redirect"
import setFiscalyear            from "../../infraMonitor/fiscalyear/actions"
import { getStaticDataSuccess } from "../../infraMonitor/staticData/actions"
import {
    About,
    Contact,
    Glossary,
    Home,
    HowToUse,
    PageNotFound,
    PrivacyPolicy,
    ProjectDetail,
    ProjectList,
    LocalProjectList,
    LocalProjectDetail
}                               from "../../pages"
import {defaultMunicipality} from "../../config/subDomain";
import {isSegregated} from "../../utils/core-helpers";

class Municipality extends Component {
    componentWillMount() {
        const { dispatchStaticData, fiscalYear, municipality } = this.props
        dispatchStaticData(fiscalYear, municipality)
    }

    render() {
        const { municipality } = this.props

        if (this.props.loading) {
            return <Loader/>
        }

        const baseName = isSegregated() ? '/' : `/${municipality.title_en}/`;

        return (
            <BrowserRouter basename={baseName}>
                <div className="page-wrap">
                    <Switch>
                        <Route
                            exact
                            path="/"
                            render={props => <Home {...props} municipality={municipality}/>}
                        />
                        <Route
                            exact
                            path="/projects"
                            render={props => (
                                <ProjectList {...props} municipality={municipality}/>
                            )}
                        />
                        <Route
                            exact
                            path="/local-projects"
                            render={props => (
                                <LocalProjectList {...props} municipality={municipality}/>
                            )}
                        />
                        <Route
                            path="/projects/:id"
                            render={props => (
                                <ProjectDetail {...props} municipality={municipality}/>
                            )}
                        />
                        <Route
                            path="/local-projects/:id"
                            render={props => (
                                <LocalProjectDetail {...props} municipality={municipality}/>
                            )}
                        />
                        <Route exact path="/about" component={About}/>
                        <Route
                            exact
                            path="/contact"
                            render={props => (
                                <Contact {...props} municipality={municipality}/>
                            )}
                        />
                        <Route exact path="/glossary" component={Glossary}/>
                        <Route exact path="/how-to-use" component={HowToUse}/>
                        <Route exact path="/privacy-policy" component={PrivacyPolicy}/>
                        <Route exact path="/(login|admin)/" component={RedirectAdmin}/>
                        <Route path="*" component={PageNotFound}/>
                    </Switch>
                </div>
            </BrowserRouter>
        )
    }
}

const mapStateToProps = state => {
    return {
        fiscalYear: state.fiscalYearReducers.selectedFiscalYear,
        loading: state.staticData.loading,
    }
}

const mapDispatchToProps = dispatch => ({
    dispatchStaticData: (year, municipality) => {
        infraMonitorService.getStaticData(municipality.title_en)
                           .then(response => {
                               const {
                                   issue_types,
                                   project_statuses,
                                   urgency_level,
                                   fiscal_years,
                                   budget_ranges,
                                   municipalities,
                                   project_budget_program_types,
                                   project_budget_program_sub_types
                               } = response.data

                               const currentMunicipality = municipalities.find(m => m.name === municipality.title_en)
                               if (currentMunicipality.length <= 0) {
                                   throw new Error("This site is not ready yet.")
                               }

                               let fiscalYear = fiscal_years.find(fy => fy.name === year)

                               if (!fiscalYear) {
                                   fiscalYear = fiscal_years.find(fy => fy.is_current)
                               }

                               if (!fiscalYear) {
                                   fiscalYear = fiscal_years[fiscal_years.length - 1]
                               }
                               
                               dispatch(setFiscalyear(fiscalYear.name))

                               dispatch(
                                   getStaticDataSuccess({
                                       issueTypes: issue_types,
                                       projectStatuses: project_statuses,
                                       urgencyLevel: urgency_level,
                                       fiscalYears: fiscal_years,
                                       budgetRanges: budget_ranges,
                                       municipalities: municipalities,
                                       projectBudgetProgramTypes: project_budget_program_types,
                                       projectBudgetProgramSubTypes: project_budget_program_sub_types,
                                   }),
                               )
                           })
    },
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Municipality)



// WEBPACK FOOTER //
// ./src/pages/municipality/municipality.js